import { FC } from 'react';
import { KpiData } from '../utils/derive';
import { BucketKey, SEVERITY, BUCKET_LABELS } from '../utils/aging';

interface KpiStripProps {
  kpis: KpiData;
}

// Whole-dollar formatter (KPI + company summaries)
function money0(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

const BUCKET_KEYS: BucketKey[] = ['current', 'b30', 'b60', 'b90', 'b120', 'b120p'];

const KpiStrip: FC<KpiStripProps> = ({ kpis }) => {
  const distTotal = BUCKET_KEYS.reduce((s, k) => s + kpis.distribution[k], 0);

  return (
    <div className="ia-kpi-strip">
      <div className="ia-kpi-card">
        <div className="ia-kpi-label">Total Outstanding</div>
        <div className="ia-kpi-value">{money0(kpis.totalOutstanding)}</div>
      </div>

      <div className="ia-kpi-card kpi-past-due">
        <div className="ia-kpi-label">Past Due</div>
        <div className="ia-kpi-value">{money0(kpis.pastDue)}</div>
      </div>

      <div className="ia-kpi-card kpi-over-90">
        <div className="ia-kpi-label">Over 90 Days</div>
        <div className="ia-kpi-value">{money0(kpis.over90)}</div>
      </div>

      <div className="ia-kpi-distribution">
        <div className="ia-kpi-label">Aging Distribution (Invoiced)</div>
        <div className="ia-dist-bar">
          {distTotal > 0 &&
            BUCKET_KEYS.map((k) => {
              const pct = (kpis.distribution[k] / distTotal) * 100;
              if (pct <= 0) return null;
              return (
                <div
                  key={k}
                  className="ia-dist-segment"
                  style={{ width: `${pct}%`, background: SEVERITY[k].bar }}
                  title={`${BUCKET_LABELS[k]}: ${money0(kpis.distribution[k])}`}
                />
              );
            })}
        </div>
        <div className="ia-dist-legend">
          {BUCKET_KEYS.filter((k) => kpis.distribution[k] > 0).map((k) => (
            <div key={k} className="ia-dist-item">
              <div className="ia-dist-dot" style={{ background: SEVERITY[k].bar }} />
              <span>{BUCKET_LABELS[k]}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KpiStrip;
